import { render, staticRenderFns } from "./WhatsappMessages.vue?vue&type=template&id=3351ec6d&scoped=true"
import script from "./WhatsappMessages.vue?vue&type=script&lang=js"
export * from "./WhatsappMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351ec6d",
  null
  
)

export default component.exports